// routes.js
import { useContext } from "react";
import { ExperimentContext } from "context";

import ProfileOverview from "layouts/pages/profile/profile-overview";
import MyLibrary from "layouts/pages/my-library";
import Settings from "layouts/pages/account/settings";
import JobsDashboard from "cruds/jobs-dashboard";
import MDAvatar from "components/MDAvatar";
import { Icon, Badge } from "@mui/material";
import profilePicture from "assets/images/team-3.jpg";
import Certificates from "layouts/pages/my-certificates";
import VisitedJobs from "layouts/pages/visited-jobs";
import Feedback from "layouts/pages/feedback";
import AddCourse from "layouts/pages/add-course";
import AddJob from "layouts/pages/add-job";
import AddDeal from "layouts/pages/add-deal";
import Deals from "layouts/pages/deals";
import CourseCatalog from "layouts/pages/course-catalog";
import QULabs from "layouts/pages/labs/QULabs";
import HomePage from "layouts/pages/home-page";
import CouponForm from "layouts/pages/add-coupons";
import UserManagement from "cruds/user-management";
import AnalyticsDashboard from "layouts/dashboards/AnalyticsDashboard";
import CustomFeedbackEndpoints from "layouts/pages/custom-feedback-endpoints";

export const useAppRoutes = () => {
  const { experimentationEnabled } = useContext(ExperimentContext);

  const RoutesWithExperiment = [
    {
      type: "collapse",
      name: "My Profile",
      key: "user-name",
      route: "profile",
      component: <Settings />,
      icon: <Icon>account_circle</Icon>,
      noCollapse: true,
    },
    {
      type: "hidden",
      name: "Account Details",
      key: "account-details",
      route: "account-details",
      icon: <Icon>account_circle</Icon>,
      component: <Settings />,
      noCollapse: true,
    },
    { type: "divider", key: "divider-1" },
    {
      type: "bottom",
      name: "Home",
      key: "home-page",
      route: "home-page",
      icon: <Icon>home</Icon>,
      noCollapse: true,
      component: <HomePage />,
    },
    {
      type: "hidden",
      name: "Feedback",
      key: "feedback",
      route: "feedback",
      icon: <Icon>feedback</Icon>,
      noCollapse: true,
      component: <Feedback />,
    },
    {
      type: "bottom",
      name: "Course Catalog",
      key: "course-catalog",
      route: "course-catalog",
      icon: <Icon>dashboard</Icon>,
      noCollapse: true,
      component: <CourseCatalog />,
    },
    {
      type: "bottom",
      name: "My Courses",
      key: "library",
      route: "library",
      icon: <Icon>book</Icon>,
      component: <MyLibrary />,
      noCollapse: true,
    },
    {
      type: "bottom",
      name: "My Certificates",
      key: "my-certificates",
      route: "my-certificates",
      icon: <Icon>card_membership</Icon>,
      noCollapse: true,
      component: <Certificates />,
    },
    {
      name: "Access Code",
      key: "my-coupons",
      route: "my-coupons",
      icon: <Icon>add_card</Icon>,
      component: <CouponForm />,
      type: "bottom",
      noCollapse: true,
      visibility: "admin",
    },
    {
      name: "Add/Edit Course",
      key: "add-course",
      route: "add-course",
      component: <AddCourse />,
      icon: <Icon>edit</Icon>,
      type: "bottom",
      noCollapse: true,
      visibility: "admin",
    },
    {
      name: "Users",
      key: "users",
      route: "users",
      component: <UserManagement />,
      icon: <Icon>people</Icon>,
      type: "bottom",
      noCollapse: true,
      visibility: "admin",
    },
    {
      name: "Analytics",
      key: "analytics",
      route: "analytics",
      component: <AnalyticsDashboard />,
      icon: <Icon>analytics</Icon>,
      type: "bottom",
      noCollapse: true,
      visibility: "admin",
    },
    {
      name: "Feedback Endpoints",
      key: "feedback-endpoints",
      route: "feedback-endpoints",
      component: <CustomFeedbackEndpoints />,
      icon: <Icon>alternate_email</Icon>,
      type: "bottom",
      noCollapse: true,
      visibility: "admin",
    },
  ];

  return RoutesWithExperiment;
};

export default useAppRoutes;
